import { render, staticRenderFns } from "./HbStatusGeneral.vue?vue&type=template&id=7f8b23bb&scoped=true&"
import script from "./HbStatusGeneral.vue?vue&type=script&lang=js&"
export * from "./HbStatusGeneral.vue?vue&type=script&lang=js&"
import style0 from "./HbStatusGeneral.vue?vue&type=style&index=0&id=7f8b23bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b23bb",
  null
  
)

export default component.exports